<template>
  <crud-table
    :create-route="{
      name: 'leagues.rewards.create',
      params: { leagueId: leagueId },
    }"
    :columns="fields"
    vuex-prefix="league_rewards"
    create-role="Developer"
    :fetch-address="fetchAddress"
  >
    <template #cell(logoAdd)="data">
      <img style="height: 40px" :src="data.item.logoAdd" />
    </template>
    <template #cell(isActive)="data">
      <switches
        :emit-on-mount="false"
        @input="setStatus(data.item.id)"
        v-model="data.item.isActive"
        type-bold="true"
        color="green"
        class="mb-0"
      ></switches>
    </template>
    <template #cell(actions)="data">
      <table-action-buttons
        fa-title="جایزه"
        route="leagues"
        :record-id="data.item.id"
        :edit-route="{
          name: 'leagues.rewards.edit',
          params: { leagueId: leagueId, id: data.item.id },
        }"
        :show-route="{
          name: 'leagues.rewards.show',
          params: { leagueId: leagueId, id: data.item.id },
        }"
        :delete-route="`leagues/${leagueId}/rewards/${data.item.id}`"
        :delete-title="data.item.name"
        @deleted="data.itemDeleted(data.itemDeleted(data.item))"
        role="Developer"
        permission="league_reward"
      >
      </table-action-buttons>
    </template>
  </crud-table>
</template>

<script>
export default {
  props: {
    leagueId: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    fetchAddress() {
      return `leagues/${this.leagueId}/rewards`;
    },
  },
  data() {
    return {
      fields: [
        {
          key: "name",
          sortable: true,
          label: "نام جایزه",
          thStyle: { width: "180px" },
          filter: {
            component: "SearchFilter",
            operator: "$lk",
            value: "",
          },
        },
        {
          key: "logoAdd",
          sortable: false,
          label: "آیکن",
          thClass: "d-none d-md-table-cell",
          tdClass: "d-none d-md-table-cell",
          thStyle: { width: "80px" },
        },
        {
          key: "startPos",
          sortable: true,
          label: "از رتبه",
          thClass: "d-none d-md-table-cell",
          tdClass: "d-none d-md-table-cell",
          thStyle: { width: "100px" },
          filter: {
            component: "NumberFilter",
            operator: "$eq",
            value: "",
          },
        },
        {
          key: "endPos",
          sortable: true,
          label: "تا رتبه",
          thClass: "d-none d-md-table-cell",
          tdClass: "d-none d-md-table-cell",
          thStyle: { width: "100px" },
          filter: {
            component: "NumberFilter",
            operator: "$eq",
            value: "",
          },
        },
        {
          key: "isActive",
          sortable: true,
          label: "وضعیت",
          thClass: "d-none d-md-table-cell",
          tdClass: "d-none d-md-table-cell",
          thStyle: { width: "100px" },
          filter: {
            component: "SwitchFilter",
            operator: "$eq",
            value: 1,
          },
        },
      ],
    };
  },
  methods: {
    setStatus(id) {
      this.$axios
        .put(`leagues/${this.leagueId}/rewards/${id}/set-status`)
        .then(() => {
          this.$swal.fire("موفق!", `وضعیت کد با موفقیت تغییر یافت`, "success");
        })
        .catch((er) => {
          this.$swal.fire("ناموفق!", er.response.data.error, "error");
        });
    },
  },
};
</script>
